export default "__VITE_ASSET__BWvdhc3L__"